import react from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";


function ModalExamenes(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');
    const [horaInicial, setHoraInicial] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});


    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [examenSeleccionado, setExamenSeleccionado] = useState(null);

    // 🎯 ESTADOS PARA ACORDEONES REACT
    const [acordeonFechaHora, setAcordeonFechaHora] = useState(true);
    const [acordeonContenido, setAcordeonContenido] = useState(false);

    const logoImg = '/smile/dist/img/logo-2.png';

    let history = useHistory();
    let userdata = [];
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-examenes', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        //cargaritems();

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/examenes', config2)
            .then(response => {
                console.log('Respuesta examenes:', response.data);
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    // 🎨 FORMATO TABLA CON BANDAS GRISES (igual que vista individual)

                    // 1. Tabla de información (Fecha y Profesional)
                    let segmentoCabecera = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>`;

                    // Profesional Tratante
                    if (item.profesional_tratante_completo && item.profesional_tratante_completo !== 'No registrado') {
                        segmentoCabecera += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional_tratante_completo}</td>
                                    </tr>`;
                    } else {
                        segmentoCabecera += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; color: #6c757d; font-style: italic;">No registrado</td>
                                    </tr>`;
                    }

                    segmentoCabecera += `
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de contenido (Ayuda Diagnóstica)
                    let segmentoContenido = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">AYUDA DIAGNÓSTICA</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                            ${item.contenido || 'Sin contenido especificado'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 3. Tabla de firma (solo si hay profesional tratante registrado)
                    let tablaFirma = '';
                    let tieneProfesionalRegistrado = (item.profesional_tratante_completo &&
                        item.profesional_tratante_completo !== 'No registrado');

                    if (tieneProfesionalRegistrado && item.profesional && item.firma) {
                        tablaFirma = `
                            <div style="margin-top: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <img src="${item.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                                <div style="margin-top: 6px; font-size: 12px; color: #6c757d;">
                                                    ${item.profesional}<br/>
                                                    <strong>RM:</strong> ${item.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${item.codigo_habilitacion || 'N/A'}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 4. Separador entre examenes
                    let separadorExamenes = `<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">`;

                    const itemParcial = segmentoCabecera + segmentoContenido + tablaFirma + separadorExamenes;

                    consolidadoItems += itemParcial;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log('Error cargando examenes:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }


    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }

    const establecerFechaHoraActual = () => {
        const ahora = new Date();
        const fechaFormateada = ahora.toISOString().slice(0, 16);
        setFechaHora(fechaFormateada);
        setHoraInicial(fechaFormateada);
    }




    const handleSubmit = (e) => {

        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            paciente_id: pacienteId,
            client_id: client.client_id,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            firma: firmaimg,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora || horaInicial
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config.validar_asignacion = true;
        }

        console.log('Enviando datos de examen:', config);

        axios.post('/examen', config)
            .then(response => {
                console.log('Examen guardado exitosamente:', response.data);
                setLoading(false);
                setContenido('');
                setFechaHora('');
                document.getElementById('plantillas').value = "";
                setDeshabilitarBotonGuardar(true);
                props.guardarCambios('El exámen de laboratorio ha sido agregado');
                cargaritems();
                setErrorlist({}); // Limpiar errores en caso de éxito
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando examen:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })
    }



    const verExamen = (examen) => {
        // Preparar contenido para modal de vista previa usando el MISMO formato que el PDF
        setTituloResumen('Ayuda Diagnóstica - Vista Previa');
        setExamenSeleccionado(examen); // Guardar para PDF

        // Obtener información del paciente desde props
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';

        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 🎨 USAR EL MISMO FORMATO QUE EL PDF - Estilo tabla con bandas grises

        // 1. BANNER (igual que PDF)
        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    AYUDA DIAGNÓSTICA
                </div>
            </div>`;

        // 2. Tabla de información (igual que PDF)
        let tablaInfoPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${examen.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 3. Tabla de contenido (igual que PDF)
        let tablaContenido = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">EXAMEN</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${examen.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Tabla profesional (igual que PDF)
        let tablaProfesional = '';
        if (examen.profesional_tratante_completo && examen.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 16px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${examen.profesional_tratante_completo}</td>
                            </tr>`;

            if (examen.profesional && examen.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                    <img src="${examen.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 6px; font-size: 12px; color: #6c757d;">
                                        ${examen.profesional}<br/>
                                        <strong>RM:</strong> ${examen.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${examen.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }
            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        } else {
            tablaProfesional = `
                <div style="margin-top: 16px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; color: #6c757d; font-style: italic;">No registrado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        // Unir todo el contenido con el mismo formato que el PDF
        const contenidoResumen = banner + tablaInfoPaciente + tablaContenido + tablaProfesional;

        setContenidoResumenIndividual(contenidoResumen);

        // Abrir modal de vista previa
        setShowModalResumen(true);
    }

    const nuevoExamen = () => {
        // Limpiar formulario para nuevo examen
        setExamenSeleccionado(null);
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        // Resetear acordeones
        setAcordeonFechaHora(true);
        setAcordeonContenido(false);

        // Limpiar formulario
        if (document.getElementById('plantillas')) {
            document.getElementById('plantillas').value = "";
        }
    }

    const descargarPdfExamen = () => {
        if (!examenSeleccionado) return;

        var opt = {
            margin: 10,
            filename: 'examen-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // 1. Encabezado Personalizado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del paciente
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';
        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 2. BANNER: EXAMEN / AYUDA DIAGNÓSTICA (estilo factura)
        let banner = `
            <div style="margin-bottom: 8px;">
                <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                    AYUDA DIAGNÓSTICA
                </div>
            </div>`;

        // 3. Información del Paciente y Fecha unificada (estilo tabla con bandas grises)
        let tablaInfoPaciente = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${examenSeleccionado.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Contenido del examen (con banda gris)
        let tablaContenido = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">EXAMEN</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${examenSeleccionado.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 5. Profesional Tratante y Firma (estilo tabla con bandas grises) - CON page-break-inside: avoid
        let tablaProfesional = '';
        if (examenSeleccionado.profesional_tratante_completo && examenSeleccionado.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 12px; page-break-inside: avoid;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 30%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${examenSeleccionado.profesional_tratante_completo}</td>
                            </tr>`;

            // Solo mostrar firma si hay profesional tratante registrado
            if (examenSeleccionado.profesional && examenSeleccionado.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6;">
                                    <img src="${examenSeleccionado.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 4px; font-size: 9px; color: #6c757d;">
                                        ${examenSeleccionado.profesional}<br/>
                                        <strong>RM:</strong> ${examenSeleccionado.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${examenSeleccionado.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }

            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        }

        // Unir todo el contenido
        let contenidoImpresion = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            banner +
            tablaInfoPaciente +
            tablaContenido +
            tablaProfesional +
            '</div>';

        // Generar PDF con foliación
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            pdf.save(opt.filename);
        });
    }

    const descargarPdfConsolidado = () => {
        var opt = {
            margin: 12,
            filename: 'examenes-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 4, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        // Usar encabezado personalizado si está disponible
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Banner de título
        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    HISTORIAL DE AYUDAS DIAGNÓSTICAS
                </div>
            </div>`;

        let contenidoImpresion = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            banner +
            consolidado +
            '</div>';

        // Generar PDF con foliación
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages,
                    pdf.internal.pageSize.getWidth() / 2,
                    pdf.internal.pageSize.getHeight() - 5,
                    { align: 'center' });
            }

            pdf.save(opt.filename);
        }).catch(error => {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        });
    }

    // Función para imprimir PDF consolidado
    const imprimirPdfConsolidado = () => {
        var opt = {
            margin: 12,
            filename: 'examenes-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 4, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        // Usar encabezado personalizado si está disponible
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Banner de título
        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    HISTORIAL DE AYUDAS DIAGNÓSTICAS
                </div>
            </div>`;

        let contenidoImpresion = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            banner +
            consolidado +
            '</div>';

        // Generar PDF con foliación y abrir en nueva pestaña
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages,
                    pdf.internal.pageSize.getWidth() / 2,
                    pdf.internal.pageSize.getHeight() - 5,
                    { align: 'center' });
            }

            // Abrir en nueva pestaña para imprimir
            window.open(pdf.output('bloburl'), '_blank');
        }).catch(error => {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        });
    }

    // ✅ Función para imprimir examen individual (MÉTODO CORRECTO)
    const imprimirExamen = () => {
        if (!examenSeleccionado) {
            alert('No hay examen seleccionado para imprimir');
            return;
        }

        console.log('Imprimiendo examen:', examenSeleccionado);

        var opt = {
            margin: 10,
            filename: 'examen-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // Generar el mismo contenido que en descargarPdfExamen
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';
        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // BANNER: AYUDA DIAGNÓSTICA
        let banner = `
            <div style="margin-bottom: 8px;">
                <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                    AYUDA DIAGNÓSTICA
                </div>
            </div>`;

        // Información del Paciente y Fecha unificada (estilo tabla con bandas grises)
        let tablaInfoPaciente = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${examenSeleccionado.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // Contenido del examen (con banda gris)
        let tablaContenido = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">EXAMEN</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${examenSeleccionado.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // Profesional Tratante y Firma (estilo tabla con bandas grises) - CON page-break-inside: avoid
        let tablaProfesional = '';
        if (examenSeleccionado.profesional_tratante_completo && examenSeleccionado.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 12px; page-break-inside: avoid;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 30%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${examenSeleccionado.profesional_tratante_completo}</td>
                            </tr>`;

            // Solo mostrar firma si hay profesional tratante registrado
            if (examenSeleccionado.profesional && examenSeleccionado.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6;">
                                    <img src="${examenSeleccionado.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 4px; font-size: 9px; color: #6c757d;">
                                        ${examenSeleccionado.profesional}<br/>
                                        <strong>RM:</strong> ${examenSeleccionado.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${examenSeleccionado.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }

            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        }

        let contenidoImpresion = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            banner +
            tablaInfoPaciente +
            tablaContenido +
            tablaProfesional +
            '</div>';

        // ✅ Generar PDF con foliación y MÉTODO CORRECTO (window.open + fallback)
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            // ✅ MÉTODO PRINCIPAL: Nueva pestaña
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => {
                        printWindow.print();
                    }, 500);
                };
            } else {
                // ✅ FALLBACK: iframe posicionado
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Por favor, descarga el PDF.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        }).catch(error => {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        });
    }

    const verResumen = (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);

        let segmentoProfesional = "<div class='bloque-info-profesional'>" +
            "<div class='row'>" +
            "<div class='col-md-3'>" +
            "<div class='form-group'>" +
            "<label>Profesional que atendió:</label><br />" +
            "<p>" + resumenIndividual.profesional + "<p>" +
            "</div>" +
            "</div>" +
            "<div class='col-md-3'>" +
            "<div class='form-group'>" +
            "<label>Registro médico:</label><br />" +
            "<p>" + resumenIndividual.registro_medico + "<p>" +
            "</div>" +
            "</div>" +
            "<div class='col-md-3'>" +
            "<div class='form-group'>" +
            "<label>Código de habilitación:</label><br />" +
            "<p>" + resumenIndividual.codigo_habilitacion + "<p>" +
            "</div>" +
            "</div>" +
            "<div class='col-md-3'>" +
            "<div class='form-group'>" +
            "<label>Firma:</label>" +
            "<img src='" + resumenIndividual.firma + "' class='firma-profesional-hc' />" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>";

        const contenidoResumen = "<label>Fecha:</label><br />" +
            "<p>" + resumenIndividual.fecha + "</p>" +
            "<label>Descripción:</label><br />" +
            resumenIndividual.contenido +
            segmentoProfesional;

        setContenidoResumenIndividual(contenidoResumen);
        setProfesionalResumenIndividual(resumenIndividual.profesional);
        setRegistroMedicoResumenIndividual(resumenIndividual.registro_medico);
        setCodigoHabilitacionResumenIndividual(resumenIndividual.codigo_habilitacion);
        setFirmaResumenIndividual(resumenIndividual.firma);

        // Abrir modal React
        setShowModalResumen(true);
    }


    useEffect(() => {
        cargaritems();

        // Cleanup para evitar memory leaks
        return () => {
            // Cancelar cualquier request pendiente si es necesario
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `ayudas-diagnósticas.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let evolucionCompleta = "<img src='" + logoImg + "' class='app-logo-pdf' /><h1 class='ttl-pdf'>HISTORIAL DE AYUDAS DIAGNÓSTICAS</h1>" + anamnesis + "<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(evolucionCompleta, opt);
    };

    // 🔒 VALIDACIÓN DE PERMISOS Y RENDERIZADO
    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* 🆕 PROFESIONAL TRATANTE - Siempre visible */}
                                            <div className="col-md-12">
                                                <div className="card" style={{ marginBottom: '15px' }}>
                                                    <div className="card-body" style={{ padding: '15px' }}>
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza el examen</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonFechaHora(!acordeonFechaHora)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100">
                                                            <span className="d-block w-100">
                                                                Fecha y Hora {acordeonFechaHora ? '' : '▼'}
                                                            </span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonFechaHora ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <div className="form-group">
                                                            <label>Fecha y Hora</label>
                                                            <div className="input-group">
                                                                <input type="datetime-local" className="form-control" value={fechaHora} onChange={(e) => {
                                                                    setFechaHora(e.target.value);
                                                                    setHoraInicial(e.target.value);
                                                                }} />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-primary btn-sm" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonContenido(!acordeonContenido)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100">
                                                            <span className="d-block w-100">
                                                                Contenido del Examen {acordeonContenido ? '' : '▼'}
                                                            </span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonContenido ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <label style={{ fontSize: '1rem', marginBottom: '8px' }}>Seleccione el examen de laboratorio o digite su contenido</label>
                                                        <div className="form-group">
                                                            <select name="plantillas" className="form-control" id="plantillas" onChange={(e) => setContenido(e.target.value)} >
                                                                <option></option>
                                                                {
                                                                    plantillas.map((plantilla, index) =>
                                                                        <option key={index} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        </div>
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.contenido}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label htmlFor="nombreProfesional">Firma</label>
                                                            <br></br>
                                                            <img src={firmaimg} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-primary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <a href="#" className="btn btn-primary" onClick={(e) => { e.preventDefault(); props.cerrarModal() }}>Cerrar</a>
                                        </div>
                                    </div>


                                </form>


                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de exámenes</b>

                                    {
                                        historial.map((item) =>

                                            <div className="timeline-item-container" key={item.id} onClick={() => verExamen(item)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>

                            </div>

                        </div>


                    </div>
                </section>

                <Modal show={showModalResumen} onHide={() => setShowModalResumen(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: contenidoResumenIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={imprimirExamen}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="danger" onClick={descargarPdfExamen}>
                            <i className="fas fa-file-pdf"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" onClick={() => setShowModalResumen(false)}>
                            <i className="fas fa-times"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Resumen Ayudas Diagnósticas</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={imprimirPdfConsolidado}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="danger" onClick={descargarPdfConsolidado}>
                            <i className="fas fa-file-pdf"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" onClick={() => setShowModalConsolidado(false)}>
                            <i className="fas fa-times"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalExamenes;